import { Button, Field } from "@secretaa/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router";
import { api } from "../../app/api.ts";
import { errorMessage } from "../../shared/errors.ts";
import { Form, FormError, Notice } from "../../shared/form.tsx";
import { rememberReturnTo, safeNext, withNext } from "../../shared/return-to.ts";

export function RegisterPage() {
  const { t, i18n } = useTranslation();
  const [params] = useSearchParams();
  // Đến từ lời mời (SAA-2026-011): email được mời điền sẵn, đích quay về nhớ lại cho lần đăng nhập sau khi xác minh.
  const next = safeNext(params.get("next"));
  const [email, setEmail] = useState(params.get("email") ?? "");
  const [password, setPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  if (done)
    return (
      <>
        <Notice>{t("auth.register.done", { email })}</Notice>
        {next ? <p className="mt-4 text-sm">{t("auth.register.doneInvite", { email })}</p> : null}
        <p className="mt-4 text-sm">
          <Link className="underline" to={withNext("/login", next, { email })}>
            {t("auth.verify.toLogin")}
          </Link>
        </p>
      </>
    );
  return (
    <>
      <h1 className="mb-4 text-xl font-semibold">{t("auth.register.title")}</h1>
      <Form
        label={t("auth.register.title")}
        onSubmit={async () => {
          setBusy(true);
          setError(null);
          try {
            await api.csrf();
            await api.auth.register({ email, password, displayName, locale: i18n.language === "en" ? "en" : "vi" });
            rememberReturnTo(next);
            setDone(true);
          } catch (e) {
            setError(errorMessage(t, e));
          } finally {
            setBusy(false);
          }
        }}
      >
        <FormError message={error} />
        <Field label={t("auth.fields.displayName")} autoComplete="name" required value={displayName} onChange={(e) => setDisplayName(e.target.value)} />
        <Field label={t("auth.fields.email")} type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        <Field
          label={t("auth.fields.password")}
          type="password"
          autoComplete="new-password"
          required
          minLength={10}
          hint={t("auth.register.passwordHint")}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button type="submit" disabled={busy}>
          {busy ? t("common.saving") : t("auth.register.submit")}
        </Button>
      </Form>
      <p className="mt-4 text-sm">
        {t("auth.register.hasAccount")}{" "}
        <Link className="underline" to={withNext("/login", next, email ? { email } : {})}>
          {t("auth.login.submit")}
        </Link>
      </p>
    </>
  );
}
